import React, { FC } from "react";
import classnames from "classnames";
import { LiveBarStreamDetail } from "chat/imports/types";
import LiveBarCarouselItem from "chat/liveBar/components/LiveBarCarouselItem/LiveBarCarouselItem";
import styles from "./LiveBarCarouselTrack.scss";

interface LiveBarCarouselTrackProps {
  data: LiveBarStreamDetail[];
}

export const LiveBarCarouselTrack: FC<LiveBarCarouselTrackProps> = ({
  data,
}) => {
  const streamsList = data?.map((item) => item?.stream?.id);

  return (
    <div className={classnames(styles.root)}>
      {data?.length > 0 &&
        data.map(
          (
            { anchor, viewInfo, stream, moderationLevel }: LiveBarStreamDetail,
            index: number
          ) => (
            <LiveBarCarouselItem
              key={anchor?.encryptedAccountId}
              viewInfo={viewInfo}
              anchor={anchor}
              stream={stream}
              moderationLevel={moderationLevel}
              streamsList={streamsList}
              index={index}
            />
          )
        )}
    </div>
  );
};
